import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function MeditationsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M24 11a5 5 0 0 1-5 5H6a6 6 0 0 1-.33-11.991 7.002 7.002 0 0 1 12.08-1.001A4 4 0 0 1 22 7c1.24.93 2 2.399 2 4zM6 14h13a3 3 0 0 0 1.467-5.618l-.615-.345.12-.695A2 2 0 0 0 17.5 5.063l-.75.192-.375-.676a5.002 5.002 0 0 0-9.095.763l-.252.718-.758-.051A4 4 0 1 0 6 14z" />
    </SvgIcon>
  );
}
